/**
 * @generated SignedSource<<4e54dcd94ea73b76c53e4b613bb060d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespFeaturedItemsGridLazy_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespFeaturedItemsGrid_item">;
  readonly " $fragmentType": "PdpRespFeaturedItemsGridLazy_item";
};
export type PdpRespFeaturedItemsGridLazy_item$key = {
  readonly " $data"?: PdpRespFeaturedItemsGridLazy_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespFeaturedItemsGridLazy_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespFeaturedItemsGridLazy_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespFeaturedItemsGrid_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "018348a6f57c84465112f7b3acd88692";

export default node;
